import { useEffect } from 'react';

// Supply successive static frames: favicon images cannot run CSS reliably.
export function useAnimatedFavicon(enabled = true) {
  useEffect(() => {
    if (!enabled) return;
    const icon = document.createElement('link');
    icon.rel = 'icon';
    icon.type = 'image/svg+xml';
    icon.setAttribute('sizes', 'any');
    icon.dataset.vuMeter = 'true';
    let frame = 0;
    const draw = () => {
      const bars = [0, 1, 2, 3, 4].map((bar) => {
        const height = Math.round(7 + 18 * (0.5 + 0.5 * Math.sin(frame * 0.8 + bar * 1.7)));
        return `<rect x="${4 + bar * 5}" y="${28 - height}" width="4" height="${height}" rx="1"/>`;
      }).join('');
      const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><rect width="32" height="32" rx="6" fill="#151611"/><g fill="#D7F75B">${bars}</g></svg>`;
      icon.href = `data:image/svg+xml,${encodeURIComponent(svg)}`;
      frame = (frame + 1) % 24;
    };
    draw();
    document.head.append(icon);
    // Four tiny frames per second; browsers throttle inactive tabs.
    const timer = window.setInterval(draw, 250);
    return () => { window.clearInterval(timer); icon.remove(); };
  }, [enabled]);
}
